import { campaignCreateActions } from '@appStore/reducers/campaignCreate'

import './style.scss'

import exclaim from 'assets/image/icons/svg/exclaim-black.svg'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { campaignHooks, campaignUtils } from 'features/campaigns'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Element } from 'react-scroll'
import { useAutomationEnded } from 'shared/connector/hooks'
import { useActionCreators, useAppSelector } from 'shared/hooks'

import ContainerStep from './step'

export function CampaignSteps() {
	campaignHooks.useValidId()
	const { campaign, isLoading, isSuccess, refetch } = campaignHooks.useCurrent()

	useAutomationEnded(() => {
		refetch()
	})
	const legacy = campaignHooks.useLegacyAdapt()

	const isAddStepsAllowed = campaign && campaignUtils.isAllowAddSteps(campaign)

	useSyncFinishStep()
	const navigate = useNavigate()

	if (isLoading || !legacy.isReady) {
		return <FullLoader size={60} />
	}

	return (
		<Element
			className='steps-template app-scroll'
			id='homeTemplateContainerID'
			name='container'
		>
			<div className='flex-container-arrow'>
				<Element
					className='steps-template-header'
					name='myScrollToElement-zoomed-message'
				>
					<h3>{campaign?.name}</h3>
				</Element>
			</div>

			{!isAddStepsAllowed && isSuccess && (
				<div className='edit-notification'>
					<img
						alt='exclaim'
						className='edit-notification__icon'
						src={exclaim}
					/>
					<p className='edit-notification__text'>
						The campaign has already started, editing is limited
					</p>
				</div>
			)}

			{isSuccess && <ContainerStep navigate={navigate} />}
		</Element>
	)
}

function useSyncFinishStep() {
	const count = useAppSelector(state => state.campaign.count)
	const { setFinishStep } = useActionCreators(campaignCreateActions)

	useEffect(() => {
		setFinishStep(count > 0 ? '1' : '2')
	}, [count, setFinishStep])
}
